import React, { useEffect, useState, useContext } from "react";
import { GlobalContext } from "../../Contexts/GlobalContext";
import { Container } from "./styled";
import { Link } from "react-router-dom";
import styles from "../../styles/Home.module.scss";
import { useHistory } from "react-router";
import secureLocalStorage from "react-secure-storage";

const SuscriptionsPackages = ({ appData }) => {
  const [activePlan, setActivePlan] = useState(null);
  const [isFormPopupActive, setIsFormPopupActive] = useState(false);
  const history = useHistory();
  const userLocal = secureLocalStorage.getItem("userLocal");
  const sessionUserId = secureLocalStorage.getItem("userId");
  const userAuth = secureLocalStorage.getItem("userAuth");

  // Datos estructurados JSON-LD
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Paquetes de suscripción",
    description: "Paquetes de suscripción para plataforma Deportactico.",
    image: "https://deportacticoapp.vercel.app/assets/Logo.png",
    offers: [
      {
        "@type": "Offer",
        priceCurrency: "ARS",
        price: "0",
        name: "Paquete Básico",
        description:
          "Paquete gratuito con estadísticas esenciales para entrenadores y jugadores.",
        url: "/app/register",
      },
      {
        "@type": "Offer",
        priceCurrency: "ARS",
        price: "5000",
        name: "Paquete Premium",
        description: "Acceso a análisis avanzado para entrenadores y equipos.",
        url: "/app/register",
      },
      {
        "@type": "Offer",
        priceCurrency: "ARS",
        price: "Let's talk",
        name: "Paquete Club",
        description:
          "Paquete personalizado para clubes con acceso total a nuestras herramientas.",
        url: "/app/register",
      },
    ],
  };

  const handleSubscribe = async () => {
    if (!userLocal) {
      history.push("/app/register");
      return;
    } else if (
      userLocal !== undefined &&
      userLocal !== null &&
      userLocal.plan === "Premium"
    ) {
      alert(`Ya estas suscripto al plan: Premium`);
    }
    const plan = {
      id: "2c9380848cee0ea5018d12b797821a64", // Deportactico Premium
    };

    try {
      const response = await fetch(
        "https://deportactico-vercel-serverless.vercel.app/api/create-subscription",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            planId: plan.id,
            userId: sessionUserId,
            email: userLocal.mail,
          }),
        }
      );
      const data = await response.json();
      if (data.error) throw new Error(data.error);
      // Redirige al usuario para aceptar la suscripción
      window.location.href = data.init_point;
    } catch (error) {
      console.error("Subscription error:", error);
    }
  };

  return (
    <Container>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <div className="packages-container">
        <div className="package">
          <div className="package-price">
            <p>Gratis</p>
          </div>
          <h3 className={styles.dynamicHeaderh3}>
            Paquete <br />
            Básico
          </h3>
          <hr></hr>
          <p>
            Ideal para entrenadores y jugadores que buscan mejorar su
            rendimiento a través de estadísticas esenciales.
          </p>
          <ul>
            <li>Libro de jugadas</li>
            <li>Tabla de estadísticas de clubes</li>
            <li>Tabla de estadísticas de jugadores</li>
          </ul>
          <Link to="/app/register" className="btn-primary">
            Crear cuenta
          </Link>
        </div>
        <div className="package premium">
          <div className="package-price">
            <p>$5.000 ARS/mes</p>
          </div>
          <h3 className={styles.dynamicHeaderh3}>
            Paquete <br />
            Premium
          </h3>
          <hr></hr>
          <p>
            Nuestra solución más completa para entrenadores y equipos que desean
            profundizar en el análisis avanzado.
          </p>
          <ul>
            <li>Libro de jugadas</li>
            <li>Tabla de estadísticas de clubes</li>
            <li>Tabla de estadísticas de jugadores</li>
            <li>Perfiles de estadísticas de clubes</li>
            <li>Perfiles de estadísticas de jugadores</li>
            <li>Analiticas comparativas entre equipos</li>
            <li>Futuras funciones de la plataforma</li>
          </ul>
          <a
            className="btn-primary ghost"
            onClick={(e) => handleSubscribe("Premium")}
          >
            Suscribirme
          </a>
        </div>
        <div className="package">
          <div className="package-price">
            <p>Let's talk</p>
          </div>
          <h3 className={styles.dynamicHeaderh3}>
            Paquete <br />
            Club
          </h3>
          <hr></hr>
          <p>
            Diseñado para clubes profesionales que requieren acceso total a
            todas nuestras herramientas y servicios.
          </p>
          <ul>
            <li>Todo lo que incluye el plan Premium</li>
            <li>Descuento por múltiples cuentas Premium</li>
            <li>
              Ideal para ligas, equipos, jugadores, organizaciones, clubes o
              agentes
            </li>
          </ul>
          <a
            className="btn-primary ghost"
            onClick={() => setIsFormPopupActive(true)}
          >
            Consultanos
          </a>
        </div>
      </div>
      {isFormPopupActive ? (
        <div className="popup-container">
          <div className="form-container">
            <h3>Contactate con ventas para tener más informacion.</h3>
            <form
              action="https://formsubmit.co/mmraverageman@gmail.com"
              method="POST"
            >
              <div className="personal-container">
                <div className="buyer-name">
                  <div className="form-group">
                    <label>Nombre</label>
                    <input type="text" name="name" required />
                  </div>
                  <div className="form-group">
                    <label>Apellido</label>
                    <input type="text" name="lastname" required />
                  </div>
                  <div className="form-group mail">
                    <label>Mail</label>
                    <input type="email" name="mail" required />
                  </div>
                </div>
                <div className="form-group messagge">
                  <label>Mensaje</label>
                  <input type="text" name="messagge" required />
                </div>
              </div>

              <div className="form-group">
                <input
                  type="hidden"
                  name="_next"
                  value="https://deportacticoapp.vercel.app/ThankYou"
                />
              </div>
              <div className="form-group">
                <input
                  type="hidden"
                  name="_subject"
                  value="CONSULTA DE SUSCRIPCIÓN"
                />
              </div>
              <div className="form-group ">
                <input type="hidden" name="_captcha" value="false" />
              </div>
              <div className="form-group buttons">
                <button
                  className="btn-primary ghost"
                  type="submit"
                  style={{ margin: "2rem auto" }}
                  onClick={(e) => setIsFormPopupActive(false)}
                >
                  CANCELAR
                </button>
                <button
                  className="btn-primary"
                  type="submit"
                  style={{ margin: "2rem auto" }}
                >
                  CONSULTAR
                </button>
              </div>
            </form>
          </div>
        </div>
      ) : null}
    </Container>
  );
};

export default SuscriptionsPackages;
